var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.518,
    height: 15.106,
    viewBox: "0 0 23.518 15.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1611",
    "data-name": "Group 1611",
    transform: "translate(-1042.778 -744.447)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view_2_",
    "data-name": "view (2)",
    transform: "translate(1043 651.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(0 92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M22.927,99.739c-.206-.282-5.118-6.9-11.39-6.9S.352,99.457.146,99.739a.761.761,0,0,0,0,.9c.206.282,5.118,6.9,11.39,6.9s11.184-6.623,11.39-6.9A.761.761,0,0,0,22.927,99.739Zm-11.39,6.281c-4.621,0-8.623-4.4-9.807-5.832,1.183-1.438,5.177-5.831,9.807-5.831s8.622,4.395,9.807,5.832C20.161,101.627,16.167,106.02,11.537,106.02Z",
    transform: "translate(0 -92.835)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(6.973 95.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M159.286,154.725a4.564,4.564,0,1,0,4.564,4.564A4.569,4.569,0,0,0,159.286,154.725Zm0,7.607a3.043,3.043,0,1,1,3.043-3.043A3.046,3.046,0,0,1,159.286,162.332Z",
    transform: "translate(-154.722 -154.725)",
    fill: "#004c75",
    stroke: "#fff",
    strokeWidth: 0.4
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.2b0593f4fb66d7402fb18d9d3fa6cebe.svg";
export { ForwardRef as ReactComponent };